import { ReactElement, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import Dropdown from 'components/v2/Dropdown'
import { DotsIcon } from 'components/Icons/DotsIcon'
import IconButton from 'components/v2/IconButton'
import List from 'components/v2/List'
import { PencilIcon } from 'components/Icons/PencilIcon'
import { GTTVehicle } from 'gql/types.generated'
import { ChangeVehicleStatusModal } from 'features/Vehicles/components/ChangeVehicleStatusModal'
import { SwitchIcon } from 'components/Icons/SwitchIcon'

interface IVehicleActionsProps {
  vehicle: GTTVehicle
}

export const VehicleActions = ({ vehicle }: IVehicleActionsProps): ReactElement => {
  const [isOpenDropdown, setOpenDropdown] = useState(false)
  const [isOpenChangeVehicleStatusModal, setOpenChangeVehicleStatusModal] = useState(false)

  const toggleDropdown = (): void => {
    setOpenDropdown(!isOpenDropdown)
  }

  const handleToggleVehicleActivation = (): void => {
    if (vehicle.partner.isActive) {
      setOpenDropdown(false)
      setOpenChangeVehicleStatusModal(true)
    }
  }

  return (
    <>
      <Dropdown.Wrapper noPadding noIndicator right onClickAway={(): TSFixMe => setOpenDropdown(false)}>
        <IconButton icon={<DotsIcon />} noBorder smallPadding onClick={toggleDropdown} />
        <Dropdown.Content open={isOpenDropdown} noIndicator left noOverflow>
          <List.Container>
            <List.ItemLink href={`/vehicles/${vehicle.id}`}>
              <List.Icon>
                <PencilIcon />
              </List.Icon>
              <FormattedMessage id="dictionary.edit" defaultMessage="Edit" />
            </List.ItemLink>
            <List.Item action onClick={handleToggleVehicleActivation} disabled={!vehicle.partner.isActive}>
              <List.Icon>
                <SwitchIcon />
              </List.Icon>
              <FormattedMessage id="vehicles.actions.changeStatus" defaultMessage="Change status" />
            </List.Item>
          </List.Container>
        </Dropdown.Content>
      </Dropdown.Wrapper>
      {isOpenChangeVehicleStatusModal ? (
        <ChangeVehicleStatusModal vehicle={vehicle} closeModal={(): void => setOpenChangeVehicleStatusModal(false)} />
      ) : null}
    </>
  )
}
